/*
  This is the exception wrapper for steps
 */

import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from "react-redux";
import AttributeStep from "../steps/AttributeStep";
import ElementAttributeStep from "./ElementAttributeStep";
import {hasMatchingParentAttribute, removeElement} from "../../store/product/productElementsSlice";
import ElementOptionalAttributeStep from "./ElementOptionalAttributeStep";
import ElementReorderButtons from "./ElementReorderButtons";
import RowConfigStep from "../steps/RowConfigStep";
import {toggleElementShowingHidden} from "../../store/configuratorStateSlice";
import SectionNumberField from "./SectionNumberField";
import ElementLoader from "../loaders/ElementLoader";
// import {generateShapesFromSummary} from "../../store/product/productSelectionsSlice";

// import AttributeStep from './steps/AttributeStep';
// import OptionalAttributeStep from "./steps/OptionalAttributeStep";
// import PatternStepByStep from "./PatternStepByStep";

// import RowConfigStep from "./steps/RowConfigStep";

const ElementStepByStep = (props) => {
    const elements = useSelector(state => state.productElementsReducer.elements_with_selections);
    const elementsDisplayingOptions = useSelector(state => state.configuratorStateReducer.elementsDisplayingOptions);
    const shapedAttributes = useSelector(state => state.productSelectionsReducer.shapedAttributes);
    const elementsShowingHidden = useSelector(state => state.configuratorStateReducer.elementsShowingHidden);
    const parentAttributes = useSelector(state => state.productDataReducer.product_attributes);
    const dispatch = useDispatch();
    const [readOnly, setReadOnly] = useState(false);


    if(shapedAttributes.length > 0) {
        return null
    }


    const displaySteps = (ele, key) => {
        const steps = [];
        // product selector sets the first attribute selection, it copies attribute from
        // returned attribute options, and sets value to nil.
        if(ele.attribute_selections != null) {

            // every
            ele.attribute_selections.filter(as => !as.optional && !as.per_module).forEach(function (el, index) {
                steps.push(<ElementAttributeStep key={'element-' + key + '-' + el.id} elementKey={key} attributes={el} currentValue={el.selection} index={index} disabled={readOnly} />)
            });
        }
        return (
            steps
        )
    }

    const displayOptions = (id) => {
        if(elementsDisplayingOptions.includes(id)) {
            const options = elements[id].product_attributes.filter(pa => pa.optional && (pa.per_module || !hasMatchingParentAttribute(parentAttributes, pa)));
            const hiddenOptions = elements[id].product_attributes.filter(pa => pa.optional && (hasMatchingParentAttribute(parentAttributes, pa) || !pa.per_module));
            const perModuleAttributes = elements[id].product_attributes.filter(pa => pa.optional && pa.per_module && !pa.read_only);
            const optionSelections = elements[id].attribute_selections.filter(as => as.optional);
            const perModuleSelections = elements[id].per_module_selections;
            return (
                <div>
                    <ElementOptionalAttributeStep key={`hidden-options-showing-${elementsShowingHidden.includes(id)}`} options={hiddenOptions} currentValues={optionSelections} elementKey={id} hasHiddenFields={true}/>
                    <ElementOptionalAttributeStep key={`no-hidden-options`} options={options} currentValues={optionSelections} elementKey={id} hasHiddenFields={false}/>
                    <RowConfigStep selections={perModuleSelections} attributes={perModuleAttributes} elementId={id} isElement={true}/>
                </div>
            )
        } else {
            return null;
        }
    }

    const displayElementPartialCatalog = (element) => {
      let partial = element.family;
      for(let sel of element.attribute_selections){
          partial += sel.selection
      }
      return partial.slice(3,5);

    }

    const getSectionKey = (element, index) => {
        return `section-${element.family}-${element.section_number}`
    }

    const displayElements = () => {
        return (elements.map((element, i) => {
                const elementNumber = element.group_line_number ? element.group_line_number : i + 1;
                return (
                    <div className="configurator-step element-wrapper" key={"element-" + i}>
                        <div className="pattern-title-wrapper">
                            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                <h2>Element {elementNumber} - {displayElementPartialCatalog(element)}</h2>
                                <SectionNumberField element={element} elementKey={i} key={getSectionKey(element, i)}
                                                    disabled={readOnly}/>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                }}>
                                    <span style={{padding: '5px 10px', cursor: 'pointer', marginBottom: '1.25rem'}}
                                          onClick={() => dispatch(toggleElementShowingHidden(i))}>Show Hidden</span>
                                    <ElementReorderButtons elementId={i} disabled={readOnly}/>
                                    <span style={{color: 'white'}}
                                          className={'button no-chevron ' + (readOnly ? 'disabled' : '')}
                                          onClick={() => {
                                              if (!readOnly) {
                                                  dispatch(removeElement(i))
                                              }
                                          }}>Delete</span>
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            {displaySteps(element, i)}
                            {displayOptions(i)}
                        </div>
                    </div>)
            })
        )
    }
    const displayShapesHeader = () => {
        if(shapedAttributes.length === 0 || elements.length === 0) {
            return null

        }
        return (<div className="pattern-title-wrapper">
                    <div style={{display: 'flex', justifyContent:'space-between', alignItems: 'center'}}>
                        <h2 style={{padding: '50px 0 15px'}}>Generated Elements</h2>
                    </div>
                </div>)
    }

    return (
        <div className="panel" id="element-steps">
            <div className={`${shapedAttributes.length === 0 ? 'is-pattern' : 'is-shape'}`}>
                {displayShapesHeader()}
                {displayElements()}
            </div>
        </div>
    )

}

export default ElementStepByStep;
